import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tJohnstonCompanies/Handlers/CustomHandlerCreator";
import { getCustomOrderHistory } from "@tJohnstonCompanies/Services/CustomOrderHistory";

type OrderParameter = {
    onError?: (error: string) => void;
} & HasOnSuccess;

type HandlerType = CustomApiHandler<OrderParameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getCustomOrderHistory();
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const loadCustomData = createHandlerChainRunner(chain, "AddCustomOrderData");
export default loadCustomData;
